var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "corporation" },
    [
      _c("nos-component", {
        ref: "NOS_COMPONENT",
        attrs: { component: this.NOS_INSTANCE.components }
      }),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c("contents-header", {
            attrs: {
              "bg-type": true,
              title: "MPRS-01-01-07-01",
              description: "MPRS-01-01-07-02"
            }
          }),
          _c("article", { staticClass: "contents" }, [
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "ovsesCustOcntryName",
                    attrs: {
                      id: "ovsesCustOcntryName",
                      value: _vm.RBF0409E40_data.ovsesCustOcntryName,
                      disabled: "",
                      "label-i18n": "MPRS-01-01-07-03"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "owhusTelno",
                    attrs: {
                      id: "owhusTelno",
                      value: _vm.RBF0409E40_data.owhusTelno,
                      disabled: "",
                      "label-i18n": "MPRS-01-01-07-04"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "cphnNo",
                    attrs: {
                      id: "cphnNo",
                      value: _vm.RBF0409E40_data.cphnNo,
                      disabled: "",
                      "label-i18n": "MPRS-01-01-07-05"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "emad1",
                    attrs: {
                      id: "emad1",
                      value: _vm.RBF0409E40_data.emad1,
                      disabled: "",
                      "label-i18n": "MPRS-01-01-07-06"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "item-tit" }, [
                  _vm._v(_vm._s(/*자택 주소*/ _vm.$t("MPRS-01-01-07-07")))
                ]),
                _c(
                  "div",
                  { staticClass: "item-desc" },
                  [
                    _vm.RBF0409E40_data.owhusNmad
                      ? _c("input-text", {
                          ref: "owhusNmad",
                          attrs: {
                            id: "owhusNmad",
                            value: _vm.RBF0409E40_data.owhusNmad,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _c("input-text", {
                      ref: "owhusAddr1",
                      attrs: {
                        id: "owhusAddr1",
                        value: _vm.RBF0409E40_data.owhusAddr1,
                        disabled: ""
                      }
                    }),
                    _vm.RBF0409E40_data.owhusAddr2
                      ? _c("input-text", {
                          ref: "owhusAddr2",
                          attrs: {
                            id: "owhusAddr2",
                            value: _vm.RBF0409E40_data.owhusAddr2,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _vm.RBF0409E40_data.owhusAddr3
                      ? _c("input-text", {
                          ref: "owhusAddr3",
                          attrs: {
                            id: "owhusAddr3",
                            value: _vm.RBF0409E40_data.owhusAddr3,
                            disabled: ""
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "item-tit" }, [
                  _vm._v(_vm._s(/* 주소*/ _vm.$t("MPRS-01-01-07-08")))
                ]),
                _c(
                  "div",
                  { staticClass: "item-desc" },
                  [
                    _vm.RBF0409E40_data.coNmad
                      ? _c("input-text", {
                          ref: "coNmad",
                          attrs: {
                            id: "coNmad",
                            value: _vm.RBF0409E40_data.coNmad,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _c("input-text", {
                      ref: "coAddr1",
                      attrs: {
                        id: "coAddr1",
                        value: _vm.RBF0409E40_data.coAddr1,
                        disabled: ""
                      }
                    }),
                    _vm.RBF0409E40_data.coAddr2
                      ? _c("input-text", {
                          ref: "coAddr2",
                          attrs: {
                            id: "coAddr2",
                            value: _vm.RBF0409E40_data.coAddr2,
                            disabled: ""
                          }
                        })
                      : _vm._e(),
                    _vm.RBF0409E40_data.coAddr3
                      ? _c("input-text", {
                          ref: "coAddr3",
                          attrs: {
                            id: "coAddr3",
                            value: _vm.RBF0409E40_data.coAddr3,
                            disabled: ""
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c("input-text", {
                    ref: "postSendAreaDstcd",
                    attrs: {
                      id: "postSendAreaDstcd",
                      value: _vm.$te(
                        _vm.RBF0409E40_data.postSendAreaDstcd +
                          "_우편발송지구분코드"
                      )
                        ? _vm.$t(
                            _vm.RBF0409E40_data.postSendAreaDstcd +
                              "_우편발송지구분코드"
                          )
                        : "",
                      disabled: "",
                      "label-i18n": "MPRS-01-01-07-09"
                    }
                  })
                ],
                1
              ),
              _vm.siteCode === _vm.$config.SITECODE_OGAUC
                ? _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("input-text", {
                        ref: "postSendYn",
                        attrs: {
                          id: "postSendYn",
                          value: _vm.$te(
                            _vm.RBF0409E40_data.postSendYn + "_우편발송여부"
                          )
                            ? _vm.$t(
                                _vm.RBF0409E40_data.postSendYn + "_우편발송여부"
                              )
                            : "",
                          disabled: "",
                          "label-i18n": "MPRS-01-01-07-11"
                        }
                      }),
                      _vm.siteCode === _vm.$config.SITECODE_OGAUC
                        ? _c("div", { staticClass: "info info-etc" }, [
                            _vm._v(
                              "※ " +
                                _vm._s(
                                  /*조회 > 거래내역조회 > Statement조회 에서 조회 후 인쇄할 수 있습니다.*/ _vm.$t(
                                    "MPRS-01-01-07-13"
                                  )
                                )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "notice notice-box--type" }, [
              _c("div", { staticClass: "notice-tit" }, [
                _c("p", { staticClass: "bullet" }, [
                  _vm._v(_vm._s(/*유의사항*/ _vm.$t("MPRS-01-01-07-14")))
                ])
              ]),
              _c("div", { staticClass: "notice-cont" }, [
                _c("ul", { staticClass: "ulist bar" }, [
                  _c("li", [
                    _vm._v(
                      "- " +
                        _vm._s(
                          /*잘못된 정보로 인한 우편물 반송에 대한 책임은 당사자가 지지 않습니다.*/ _vm.$t(
                            "MPRS-01-01-07-15"
                          )
                        )
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "btn-area--full fixed" }, [
        _c(
          "button",
          { staticClass: "btn md normal", on: { click: _vm.goNextStep } },
          [_vm._v(_vm._s(/*확인*/ _vm.$t("MCOM-0000003")))]
        )
      ]),
      _c("approval-line", {
        ref: "otp",
        attrs: { NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE },
        on: { authOpen: _vm.confirmOtp }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }